import { useState } from 'react';
import { nomDuChantier } from '../../lib/nom-chantier';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { Inp } from '../../components/ui/Inputs.jsx';
import { nomComplet } from '../../lib/acces';
import { uid } from '../../lib/utils';
import { C } from '../../theme/palette';
import { localeDates, tr, trf } from '../../lib/i18n';

export function RendezVousPage({
  onNav,
  soc,
  rdv,
  setRdv,
  clients,
  chantiers,
  employes,
  estMixte,
  univers,
  setUnivers,
}) {
  const [add, setAdd] = useState(false);
  const estMag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  // Le rendez-vous de chantier est du bâtiment : le magasin reçoit ses
  // clients, et c'est le type qu'il propose d'abord.
  const TYPES = [
    ...(estMag ? [] : [['chantier', '🏗', 'Chantier']]),
    ['reunion', '👥', 'Réunion'],
    ['client', '🤝', 'Client'],
    ['autre', '📌', 'Autre'],
  ];
  const blank = {
    type: estMag ? 'client' : 'chantier',
    date: '',
    heure: '09:00',
    clientId: clients[0]?.id || '',
    chantierId: '',
    employeIds: [],
    objet: '',
    lieu: '',
  };
  const [f, setF] = useState(blank);
  const tInfo = (t) => TYPES.find((x) => x[0] === t) || TYPES[TYPES.length - 1];
  const chName = (id) => {
    const c = (chantiers || []).find((x) => x.id === id);
    return c ? c.nom : '';
  };
  const toggleEmp = (id) =>
    setF((p) => ({
      ...p,
      employeIds: (p.employeIds || []).includes(id)
        ? p.employeIds.filter((x) => x !== id)
        : [...(p.employeIds || []), id],
    }));
  const sorted = [...rdv].sort((a, b) => (a.date + a.heure).localeCompare(b.date + b.heure));
  const fmtDate = (iso) => {
    try {
      return new Date(iso + 'T00:00:00').toLocaleDateString(localeDates(), {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
      });
    } catch (e) {
      return iso;
    }
  };
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="📅 Rendez-vous"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <div style={{ marginBottom: 12 }}>
        <Btn
          label={add ? 'Fermer' : '＋ Nouveau rendez-vous'}
          color={C.navy}
          full
          onClick={() => setAdd((a) => !a)}
        />
      </div>
      {add && (
        <Card style={{ marginBottom: 12, border: '2px solid ' + C.navy }}>
          <Bar icon="📅" title="Nouveau rendez-vous" color={C.navy} />
          <div style={{ padding: 13 }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: C.muted, marginBottom: 6 }}>
              TYPE
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 11 }}>
              {TYPES.map(([id, ic, t]) => {
                const on = f.type === id;
                return (
                  <div
                    key={id}
                    onClick={() => setF((p) => ({ ...p, type: id }))}
                    style={{
                      flex: '1 1 40%',
                      textAlign: 'center',
                      border: '1.5px solid ' + (on ? C.navy : C.border),
                      background: on ? C.navyXL : C.white,
                      borderRadius: 10,
                      padding: '8px 4px',
                      cursor: 'pointer',
                      fontSize: 10,
                      fontWeight: 700,
                      color: on ? C.navy : C.ink,
                    }}
                  >
                    {ic} {t}
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <Inp
                label="Date"
                type="date"
                value={f.date}
                onChange={(e) => setF((p) => ({ ...p, date: e.target.value }))}
              />
              <Inp
                label="Heure"
                type="time"
                value={f.heure}
                onChange={(e) => setF((p) => ({ ...p, heure: e.target.value }))}
              />
            </div>
            <Inp
              label="Objet"
              value={f.objet}
              onChange={(e) => setF((p) => ({ ...p, objet: e.target.value }))}
            />
            {!estMag && f.type === 'chantier' && (
              <Inp label="Chantier">
                <select
                  value={f.chantierId}
                  onChange={(e) => {
                    const id = e.target.value;
                    const c = (chantiers || []).find((x) => x.id === id);
                    setF((p) => ({
                      ...p,
                      chantierId: id,
                      lieu: c ? [c.adr, c.npa].filter(Boolean).join(', ') : p.lieu,
                    }));
                  }}
                  style={{
                    width: '100%',
                    border: '1px solid ' + C.border,
                    borderRadius: 9,
                    padding: '10px',
                    fontSize: 11,
                  }}
                >
                  <option value="">— Choisir le chantier —</option>
                  {(chantiers || []).map((c) => (
                    <option key={c.id} value={c.id}>
                      {nomDuChantier(c, chantiers)}
                    </option>
                  ))}
                </select>
              </Inp>
            )}
            {f.type === 'client' && (
              <Inp label="Client">
                <select
                  value={f.clientId}
                  onChange={(e) => setF((p) => ({ ...p, clientId: +e.target.value }))}
                  style={{
                    width: '100%',
                    border: '1px solid ' + C.border,
                    borderRadius: 9,
                    padding: '10px',
                    fontSize: 11,
                  }}
                >
                  {clients.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nom}
                    </option>
                  ))}
                </select>
              </Inp>
            )}
            <Inp
              label="Lieu"
              value={f.lieu}
              onChange={(e) => setF((p) => ({ ...p, lieu: e.target.value }))}
            />
            <div style={{ fontSize: 9, fontWeight: 700, color: C.muted, margin: '8px 0 6px' }}>
              OUVRIERS CONVOQUÉS
            </div>
            {(employes || []).length === 0 ? (
              <div style={{ fontSize: 9, color: C.muted }}>Aucun employé enregistré.</div>
            ) : (
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {(employes || []).map((e) => {
                  const on = (f.employeIds || []).includes(e.id);
                  return (
                    <div
                      key={e.id}
                      onClick={() => toggleEmp(e.id)}
                      style={{
                        border: '1.5px solid ' + (on ? C.teal : C.border),
                        background: on ? C.teal : C.white,
                        color: on ? '#fff' : C.ink,
                        borderRadius: 99,
                        padding: '6px 11px',
                        fontSize: 9.5,
                        fontWeight: 700,
                        cursor: 'pointer',
                      }}
                    >
                      {on ? '✓ ' : ''}
                      {nomComplet(e) || e.nom}
                    </div>
                  );
                })}
              </div>
            )}
            <Btn
              label="✓ Enregistrer & convoquer"
              color={C.navy}
              full
              style={{ marginTop: 11 }}
              disabled={!f.date || !f.objet}
              onClick={() => {
                setRdv((p) => [...p, { ...f, id: uid() }]);
                setF(blank);
                setAdd(false);
              }}
            />
            <div style={{ fontSize: 8, color: C.muted, marginTop: 6, textAlign: 'center' }}>
              Les ouvriers convoqués verront ce rendez-vous dans leur espace (onglet 📅 RDV).
            </div>
          </div>
        </Card>
      )}
      {sorted.length === 0 && (
        <Card>
          <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
            Aucun rendez-vous
          </div>
        </Card>
      )}
      {sorted.map((r) => {
        const cl = clients.find((c) => c.id === r.clientId);
        const ti = tInfo(r.type);
        const noms = (r.employeIds || [])
          .map((id) => (employes || []).find((e) => e.id === id))
          .filter(Boolean)
          .map((e) => nomComplet(e) || e.nom);
        return (
          <Card key={r.id} style={{ marginBottom: 8 }}>
            <div
              style={{ padding: '11px 13px', display: 'flex', gap: 12, alignItems: 'flex-start' }}
            >
              <div
                style={{
                  textAlign: 'center',
                  flexShrink: 0,
                  background: C.navyXL,
                  borderRadius: 9,
                  padding: '7px 9px',
                }}
              >
                <div style={{ fontSize: 8, color: C.muted, textTransform: 'uppercase' }}>
                  {fmtDate(r.date)}
                </div>
                <div style={{ fontSize: 13, fontWeight: 900, color: C.navy }}>{r.heure}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <span
                    style={{
                      fontSize: 8,
                      fontWeight: 800,
                      background: C.navy,
                      color: '#fff',
                      borderRadius: 99,
                      padding: '2px 7px',
                    }}
                  >
                    {ti[1]} {ti[2]}
                  </span>
                  <span style={{ fontSize: 10.5, fontWeight: 700 }}>{r.objet}</span>
                </div>
                <div style={{ fontSize: 8.5, color: C.muted, marginTop: 3 }}>
                  {!estMag && r.type === 'chantier' && r.chantierId
                    ? '🏗 ' + chName(r.chantierId)
                    : r.type === 'client' && cl
                      ? '🤝 ' + cl.nom
                      : ''}
                  {r.lieu ? ' · 📍 ' + r.lieu : ''}
                </div>
                {(r.heureFin || r.lieuNom || r.avecQui) && (
                  <div style={{ fontSize: 8.5, color: C.muted, marginTop: 3 }}>
                    {[
                      r.heureFin ? '⏱ ' + r.heure + '–' + r.heureFin : '',
                      r.lieuNom ? '🏠 ' + r.lieuNom : '',
                      r.avecQui ? '👤 ' + r.avecQui : '',
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  </div>
                )}
                {noms.length > 0 && (
                  <div style={{ fontSize: 8.5, color: C.teal, fontWeight: 700, marginTop: 3 }}>
                    👷 {noms.join(', ')}
                  </div>
                )}
                {(r.reponses || []).length > 0 && (
                  <div
                    style={{
                      fontSize: 8.5,
                      marginTop: 3,
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 6,
                    }}
                  >
                    {(r.reponses || []).map((rep) => {
                      const e = (employes || []).find((x) => x.id === rep.employeId);
                      const nom = e ? nomComplet(e) || e.nom : '';
                      const etat =
                        rep.reponse === 'PRESENT'
                          ? tr('✓ Sera là')
                          : rep.reponse === 'ABSENT'
                            ? rep.texte
                              ? trf('✗ Ne peut pas : {0}', rep.texte)
                              : tr('✗ Ne peut pas')
                            : rep.vuLe
                              ? tr('👁 Vu')
                              : tr('Pas encore vu');
                      return (
                        <span
                          key={rep.employeId}
                          style={{
                            fontWeight: 700,
                            color:
                              rep.reponse === 'ABSENT'
                                ? C.red
                                : rep.reponse === 'PRESENT'
                                  ? C.green
                                  : C.muted,
                          }}
                        >
                          {nom} : {etat}
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>
              <button
                onClick={() => setRdv((p) => p.filter((x) => x.id !== r.id))}
                style={{ background: 'none', border: 'none', color: C.muted, cursor: 'pointer' }}
              >
                ✕
              </button>
            </div>
          </Card>
        );
      })}
    </Shell>
  );
}
